const map = {
	"./africa/designs": [
		37057,
		[
			1802,
			9588
		]
	],
	"./apac/designs": [
		12089,
		[
			1802,
			6542
		]
	],
	"./arabic/designs": [
		61900,
		[
			8393,
			1802,
			8155,
			9716
		]
	],
	"./chinese/designs": [
		41751,
		[
			8393,
			1802,
			8155,
			1044
		]
	],
	"./global/designs": [
		75655,
		[
			8393,
			1802,
			8155,
			642
		]
	],
	"./latam/designs": [
		53693,
		[
			1802,
			1668
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map((id) => (__webpack_require__.e(id)))).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 28155;
module.exports = webpackAsyncContext;